import { jsx as _jsx } from "react/jsx-runtime";
import * as react from "react";
import { Color3LineComponent } from "shared-ui-components/lines/color3LineComponent.js";
import { Color3 } from "core/Maths/math.color.js";
export class Color3PropertyTabComponent extends react.Component {
    render() {
        const target = this.props.inputBlock.runtimeValue.value;
        const foo = {
            color: new Color3(target.r, target.g, target.b),
        };
        return (_jsx(Color3LineComponent, { lockObject: this.props.stateManager.lockObject, label: this.props.inputBlock.name, target: foo, propertyName: "color", onChange: () => {
                target.r = foo.color.r;
                target.g = foo.color.g;
                target.b = foo.color.b;
                this.props.stateManager.onUpdateRequiredObservable.notifyObservers(this.props.inputBlock);
            } }));
    }
}
//# sourceMappingURL=color3PropertyTabComponent.js.map